import React from 'react';
import Sidebar from '../../../views/components/Sidebar';
import LogoMin from '../../../images/svg/logoMin';
import { Box, Divider } from '@mui/material';
import HeaderWithLogo from '../../../views/components/Sidebar/HeaderWithLogo';
import CompanyFilter from '../../../views/components/CompanyFilter';
import { ApiDocsNavItem, HelpCenterNavItem } from 'src/common/sidebar';
import LogoWithRaben from '../OrganizationSidebar/components/logoWithRaben';

export default function SuperdashboardSidebar() {
  return (
    <Sidebar isOpen>
      <HeaderWithLogo openLogo={<LogoWithRaben />} closedLogo={<LogoMin />} />
      <CompanyFilter />
      {/* In the drawer's column flow, not position: fixed: a fixed footer has
          no background of its own, so with hundreds of carriers the
          organization list ran underneath it and the rows showed through the
          links. CompanyFilter's list fills the space left above it. The
          negative margin cancels the drawer paper's 8px side padding, so the
          dividers still span the whole sidebar; they take 100% of it, not a
          fixed 320px, which is 1px wider than the paper's inner width (its
          right border) and gave the drawer a horizontal scrollbar. */}
      <Box sx={{ flexShrink: 0, mx: '-8px', pb: '5px' }}>
        <Divider sx={{ width: '100%' }} />
        <HelpCenterNavItem />
        <ApiDocsNavItem />
        <Divider sx={{ width: '100%' }} />
      </Box>
    </Sidebar>
  );
}
